import { apiClient } from './client';
import { endpoints } from './endpoints';

export type QuickLinkDto = {
  id: number;
  link_order: number;
  label: string;
  route: string;
};

export async function fetchQuickLinks(): Promise<QuickLinkDto[]> {
  const res = await apiClient.get<QuickLinkDto[]>(endpoints.quickLinks.list);
  return res.data;
}

export async function saveQuickLinks(
  links: { label: string; route: string }[],
): Promise<void> {
  await apiClient.put<void, { links: { label: string; route: string }[] }>(
    endpoints.quickLinks.save,
    { links },
  );
}
